import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationAR from './locales/ar/translation.json';
import translationDE from './locales/de/translation.json';
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import translationFR from './locales/fr/translation.json';
import translationIT from './locales/it/translation.json';
import translationNL from './locales/nl/translation.json';
import translationPT from './locales/pt/translation.json';
import translationRU from './locales/ru/translation.json';
import translationTR from './locales/tr/translation.json';
import { getSelectedLocale } from './utils/Localization';

// the translations
const resources = {
  ar: {
    translation: translationAR,
  },
  de: {
    translation: translationDE,
  },
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
  it: {
    translation: translationIT,
  },
  nl: {
    translation: translationNL,
  },
  pt: {
    translation: translationPT,
  },
  ru: {
    translation: translationRU,
  },
  tr: {
    translation: translationTR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: getSelectedLocale(),
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
